import { render, staticRenderFns } from "./CondominiumsList.vue?vue&type=template&id=385d3de6&scoped=true&"
import script from "./CondominiumsList.vue?vue&type=script&lang=js&"
export * from "./CondominiumsList.vue?vue&type=script&lang=js&"
import style0 from "./CondominiumsList.vue?vue&type=style&index=0&id=385d3de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d3de6",
  null
  
)

export default component.exports